import axios from 'axios';

import { MOI_EMAIL_TEMPLATES_ROUTES } from '~/components/GenericTemplates/utils/routes';

import type { MoiEmailTemplateFormValues } from './types';

// Save dispatch keys on `id`: null → the (Default) template has not been materialized yet → POST
// (create/materialize); an integer id → PUT (update). MOI email templates are Exposure-level only.
// `is_default` and `is_enabled` are both owned by other paths, so the edit PUT is a partial payload
// that omits them (the backend keeps the stored value for any field the request doesn't set): the
// default flag is only ever set when materializing the synthetic Default (POST is_default: true), and
// `is_enabled` is owned by the row-level PATCH toggle so a stale card read can't revert a toggle. Both
// are sent only on the create POST.
export const saveMoiEmailTemplate = async (
  organizationId: number,
  values: MoiEmailTemplateFormValues
): Promise<void> => {
  const { id, is_enabled, is_default, ...rest } = values;
  const payload = { ...rest, is_claim_level: false };

  if (id === null || id === undefined) {
    await axios.post(MOI_EMAIL_TEMPLATES_ROUTES.CREATE_TEMPLATE(organizationId), {
      ...payload,
      is_enabled,
      is_default,
    });
  } else {
    await axios.put(MOI_EMAIL_TEMPLATES_ROUTES.UPDATE_TEMPLATE(organizationId, id), payload);
  }
};

export const toggleMoiEmailTemplateEnabled = async (
  organizationId: number,
  templateId: number,
  isEnabled: boolean
): Promise<void> => {
  await axios.patch(MOI_EMAIL_TEMPLATES_ROUTES.UPDATE_TEMPLATE_IS_ENABLED(organizationId, templateId), {
    is_enabled: isEnabled,
  });
};
